import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { virtualGameCardsRouteI18n } from '../i18n/virtual-game-cards-route-i18n';

export function virtualGameCardsRoutePath(): string {
  return `/${langRouteI18n()}/${virtualGameCardsRouteI18n()}`;
}
